import { RelayApi } from 'api/ApiHelper';
import { relayQueryKey } from 'queries/relay/queryKey';
import { useQuery } from '@tanstack/react-query';

export const usePostRelayProfilesLiteQuery = ({ profileIds }: { profileIds: number[] }) =>
  useQuery({
    queryKey: relayQueryKey.profileList(profileIds),
    queryFn: () => RelayApi.profilesLite({ profileIds }),
    enabled: profileIds.length > 0,
  });
